export function calculate(inputs) {
  const { filCost=0, grams=0, hours=0, watts=0, elecRate=0,
          marginPct=0, overheadPct=0, failRate=0, laborHrs=0, laborRate=0 } = inputs

  const matCost    = (filCost / 1000) * grams
  const elecCost   = (watts / 1000) * hours * elecRate
  const laborCost  = laborHrs * laborRate
  const failBuffer = (matCost + elecCost) * (failRate / 100)
  const baseCost   = matCost + elecCost + laborCost + failBuffer
  const overheadAmt = baseCost * (overheadPct / 100)
  const totalCost  = baseCost + overheadAmt
  const clampedMargin = Math.min(marginPct, 99)
  const salePrice  = totalCost / (1 - (clampedMargin / 100))
  const profitAmt  = salePrice - totalCost

  return { matCost, elecCost, laborCost, failBuffer, overheadAmt,
           totalCost, profitAmt, salePrice, marginPct, overheadPct }
}

export const formatDollar = n =>
  (isNaN(n) || !isFinite(n)) ? '$0.00' : '$' + n.toFixed(2)

export const barPct = (value, total) =>
  (!total || total <= 0) ? '0%' : Math.min(100, (value / total) * 100).toFixed(1) + '%'